module.exports = __webpack_public_path__ + "468d80d14bc0084d5c0493c949230d75.svg";